export enum PostHogEventEnum {
  Pageview = '$pageview',
  Request = 'Request',
  AiPreviewNewsClose = 'ai_preview_news_close',
}

export enum PostHogFeatureFlagEnum {
  AiPreviewNews = 'ai_preview_news',
  SignupBackgroundTest = 'signup_background_test',
}

export enum SignupBackgroundVariant {
  Control = 'control',
  Blur = 'blur',
}

export enum PostHogUserPropertyEnum {
  AiPreviewNews = 'ai_preview_news',
}
